<template>
  <div :class="componentClassName">
    <a-page-heading>着信フロー設定 </a-page-heading>
    <m-section variant="fullpage">
      <m-action-card
        id="settingsIncomingFlows"
        :title="titleText"
        icon="calendar"
        :header-border="true"
        :narrow-body="true"
        :help="false"
        @help:click="handleHelpClick"
      >
        <form ref="form" class="t-setting-ivr-edit__form" @submit.prevent="handleFormSubmit">
          <div class="t-setting-ivr-edit__fields">
            <m-form-input label="分岐設定">
              <a-select-field id="ivrOptions" v-model="currentUseIVR" :options="ivrOptions" :disabled="viewOnly" />
            </m-form-input>
            <template v-if="currentUseIVR === '1'">
              <m-action-card
                id="currentUseIVR"
                class="t-setting-ivr-edit__field-options"
                title="着信フロー設定"
                :border="true"
                :header-border="true"
              >
                <o-response-flow-setting-list
                  v-model="currentResponseFlowList"
                  :voice-d-x-phone-number-list="voiceDXPhoneNumberList"
                  :view-only="viewOnly"
                  @config="handleResponseFlowConfig"
                />
                <div class="m-specific-number-setting__fields">
                  <a-switch v-model="withheldNumberFlag" label="非通知着信を切断" :disabled="viewOnly" />
                </div>
                <div class="m-specific-number-setting__fields">
                  <a-switch v-model="overseasNumberFlag" label="海外からの着信を切断" :disabled="viewOnly" />
                </div>
              </m-action-card>
              <m-automatic-responder-setting
                v-model:voice="currentVoice"
                v-model:content="currentContent"
                v-model:absence-mail="currentAbsenceMail"
                v-model:email-notification="currentEmailNotification"
                response-mode="basic-voice-guidance"
                :voice-list="voiceList"
                :is-voice-playing="isVoicePlaying"
                :view-only="viewOnly"
                @play="handlePlayVoice"
                @stop="handleStopVoice"
              />
            </template>
            <template v-if="currentUseIVR === '0'">
              <m-action-card
                id="currentUseIVR"
                class="t-setting-ivr-edit__field-options"
                title="着信フロー設定"
                :border="true"
                :header-border="true"
              >
                <m-form-input label="対応方法">
                  <a-select-field
                    id="responseOptions"
                    v-model="currentResponseMode"
                    :options="responseOptions"
                    :disabled="viewOnly"
                  />
                </m-form-input>
                <template v-if="currentResponseMode === 'user'">
                  <template v-if="currentResponseUserGroupType === 'current'">
                    <m-form-input label="着信グループ">
                      <a-select-field
                        id="groupName"
                        v-model="currentUserGroup"
                        :options="userGroupOptions"
                        :disabled="viewOnly"
                      />
                    </m-form-input>
                  </template>
                </template>
                <template v-if="currentResponseMode === 'transfer'">
                  <m-form-input label="電話番号">
                    <a-text-field id="phoneNumber" v-model="currentPhoneNumber" maxlength="11" :disabled="viewOnly" />
                  </m-form-input>
                </template>
                <template v-if="currentResponseMode === 'voiceDX'">
                  <m-form-input label="COTOHA Voice DX Basic番号名称">
                    <a-select-field
                      id="voiceDXPhoneNumberList"
                      v-model="currentPhoneNumber"
                      :options="voiceDXPhoneNumberList"
                      :disabled="viewOnly"
                      class="mb-64"
                    />
                  </m-form-input>
                </template>
                <m-no-ivr-automatic-voice-guidance
                  v-model:no-ivr-guidance-setting="noIvrGuidanceSetting"
                  :setting="noIvrGuidanceSetting"
                  :voice-list="voiceList"
                  :is-voice-playing="isVoicePlaying"
                  :view-only="viewOnly"
                  @play="handlePlayVoice"
                  @stop="handleStopVoice"
                />
                <template v-if="currentResponseMode === 'user'">
                  <m-dubbing-responder-setting
                    v-model:voice="currentVoice"
                    v-model:overflow-condition="currentOverflowResponseMode"
                    v-model:overflow-guidance="overflowCallGuidance"
                    v-model:overflow-transfer-number="overflowTransferNumber"
                    v-model:overflow-group-name="overflowGroupName"
                    v-model:overflow-notification="currentOverflowNotification"
                    v-model:overflow-absence-mail="overflowAbsenceMail"
                    v-model:overflow-email-notification="overflowEmailNotification"
                    class="t-setting-ivr-edit__respondersetting"
                    :dubbing-options="overflowResponseOptions"
                    :voicedx-numberlist="voiceDXPhoneNumberList"
                    :group-list="userGroupList"
                    :response-mode="currentResponseMode"
                    :voice-list="voiceList"
                    :is-voice-playing="isVoicePlaying"
                    :view-only="viewOnly"
                    @play="handlePlayVoice"
                    @stop="handleStopVoice"
                  />
                </template>
                <m-specific-number-setting
                  v-model:specific-number-setting="specificNumberSetting"
                  :setting="specificNumberSetting"
                  :original-setting="specificNumberSettingRaw"
                  :response-mode-options="specificNumberSettingOptions"
                  :user-group-options="userGroupOptions"
                  :vdx-phone-number-list="voiceDXPhoneNumberList"
                  :company-name="companyName"
                  :voice-list="voiceList"
                  :is-voice-playing="isVoicePlaying"
                  :view-only="viewOnly"
                  @play="handlePlayVoice"
                  @stop="handleStopVoice"
                />
                <div class="m-specific-number-setting__fields">
                  <a-switch v-model="withheldNumberFlag" label="非通知着信を切断" :disabled="viewOnly" />
                </div>
                <div class="m-specific-number-setting__fields">
                  <a-switch v-model="overseasNumberFlag" label="海外からの着信を切断" :disabled="viewOnly" />
                </div>
              </m-action-card>
            </template>
            <m-form-action-buttons>
              <a-button
                id="save"
                variant="block"
                color="primary"
                :disabled="savaButtonDisable || viewOnly"
                submit="submit"
              >
                保存
              </a-button>
              <a-button id="cancel" variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingIvrEdit_helpModal"
      v-model:visible="helpDialogVisible"
      class="o-modal-help-dialog"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCloseHelpDialog"
    >
      <template #title>{{ currentHelpMessageTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="currentHelpMessageText" />
        <!-- eslint-enable -->
      </a-text>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="settingIvrEdit_settingModal"
      v-model:visible="settingDialogVisible"
      class="o-modal-flow-setting"
      footer-variant="dialog"
      width="568px"
      title-icon="phone-incoming-call"
      title-icon-color="orange"
      z-index="9997"
      :title="settingModalTitle"
      :footer-shadow="true"
      :close-on-click-modal="false"
    >
      <m-form-input label="設定名称">
        <a-text-field
          id="settingName"
          v-model="formData.name"
          type="text"
          placeholder="営業問合せ"
          :disabled="viewOnly"
        />
      </m-form-input>
      <m-form-input label="対応方法" class="t-setting-ivr-edit__setting-group-name">
        <a-select-field
          v-if="isDataLoaded"
          id="settingOptions"
          v-model="formData.response_mode"
          :options="responseOptions"
          :disabled="viewOnly"
        />
      </m-form-input>
      <m-form-input v-if="formData.response_mode === 'user' && isDataLoaded" label="着信グループ名">
        <a-select-field
          id="settingGroupName"
          v-model="formData.group_name"
          :options="userGroupOptions"
          :disabled="viewOnly"
        />
      </m-form-input>
      <m-form-input v-if="formData.response_mode === 'transfer'" label="電話番号">
        <a-text-field
          id="settingPhoneNumber"
          v-model="formData.phone_number"
          type="tel"
          placeholder="0312345678"
          maxlength="11"
          :disabled="viewOnly"
        />
      </m-form-input>
      <m-form-input v-if="formData.response_mode === 'voiceDX' && isDataLoaded" label="COTOHA Voice DX Basic番号名称">
        <a-select-field
          id="settingVoiceDXPhoneNumberList"
          v-model="formData.phone_number"
          :options="voiceDXPhoneNumberList"
          :disabled="viewOnly"
          class="t-setting-ivr-edit__phonenumber"
        />
      </m-form-input>
      <template v-if="formData.response_mode === 'user' && isDataLoaded">
        <!-- あふれ呼 -->
        <m-dubbing-responder-setting
          v-model:voice="currentVoice"
          v-model:overflow-condition="formData.overflow_response_mode"
          v-model:overflow-guidance="formData.guidance"
          v-model:overflow-transfer-number="formData.transfer_number"
          v-model:overflow-group-name="formData.overflow_group_name"
          v-model:overflow-notification="formData.notification"
          v-model:overflow-absence-mail="formData.overflow_absence_mail"
          v-model:overflow-email-notification="formData.overflow_email_notification"
          class="t-setting-ivr-edit__respondersetting"
          :response-mode="currentResponseMode"
          :dubbing-options="overflowResponseOptions"
          :voicedx-numberlist="voiceDXPhoneNumberList"
          :group-list="userGroupList"
          :voice-list="voiceList"
          :is-voice-playing="isVoicePlaying"
          :view-only="viewOnly"
          @play="handlePlayVoice"
          @stop="handleStopVoice"
        />
      </template>
      <template v-if="isDataLoaded && settingDialogVisible">
        <m-specific-number-setting
          v-model:specific-number-setting="formData.specificNumberSetting"
          :setting="formData.specificNumberSetting || {}"
          :original-setting="formData.specificNumberSettingRaw"
          :response-mode-options="specificNumberSettingOptions"
          :user-group-options="userGroupOptions"
          :vdx-phone-number-list="voiceDXPhoneNumberList"
          :company-name="companyName"
          :voice-list="voiceList"
          :is-voice-playing="isVoicePlaying"
          :view-only="viewOnly"
          @play="handlePlayVoice"
          @stop="handleStopVoice"
        />
      </template>
      <template #footer>
        <a-button
          id="buttonBack"
          variant="outlined"
          color="primary"
          label="戻る"
          size="small"
          @click="handleCancelDialog"
        />
        <a-button
          id="buttonSubmit"
          variant="block"
          color="primary"
          label="設定を反映"
          size="small"
          :disabled="viewOnly"
          @click="handleSubmitDialog"
        />
      </template>
    </o-modal>
  </teleport>
  <!-- Info, Erro Modal -->
  <teleport to="body">
    <o-modal
      id="settingIvrEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <template v-if="isNormalModal">
          <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="goCallFlow" />
        </template>
        <template v-if="!isNormalModal">
          <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import OModal from '@/components/organisms/modal';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import OResponseFlowSettingList from '@/components/organisms/response-flow-setting-list';
import MAutomaticResponderSetting from '@/components/molecules/automatic-responder-setting';
import MSpecificNumberSetting from '@/components/molecules/specific-number-setting';
import MNoIvrAutomaticVoiceGuidance from '@/components/molecules/no-ivr-automatic-voice-guidance';
import ATextField from '@/components/atoms/text-field';
// import MUserSelectionTable from '@/components/molecules/user-selection-table';
// import ACaptionList from '@/components/atoms/caption-list';
import { cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';

// For Trial
import { utils } from '@/common/utils.js';

export default {
  name: 't-setting-ivr-edit',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    MFormActionButtons,
    AButton,
    OModal,
    AText,
    MFormInput,
    ASelectField,
    OResponseFlowSettingList,
    MAutomaticResponderSetting,
    ATextField,
    MSpecificNumberSetting,
    MNoIvrAutomaticVoiceGuidance,
  },
  mixins: [customRequest, messageContent, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    holidayList: {
      type: Array,
      default: new Array(0),
    },
    currentHelpMessageTitle: {
      type: String,
      default: null,
    },
    currentHelpMessageText: {
      type: String,
      default: null,
    },
    useIvr: {
      type: Boolean,
      default: true,
    },
    responseFlowList: {
      type: Array,
      default: new Array(0),
    },
    companyID: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
    dubbingNotification: {
      type: Boolean,
      default: null,
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isDataLoaded: null,
      helpDialogVisible: false,
      ivrOptions: [
        {
          label: '着信分岐設定（IVR）を利用する',
          value: '1',
        },
        {
          label: '着信分岐設定（IVR）を利用しない',
          value: '0',
        },
      ],
      responseOptions: [
        {
          label: '指定ユーザーが着信',
          value: 'user',
        },
        {
          label: '外線転送',
          value: 'transfer',
        },
      ],
      responseUserGroupOptions: [
        {
          label: '作成済みの着信グループ',
          value: 'current',
        },
        {
          label: '新規作成した着信グループ',
          value: 'new',
        },
      ],
      voiceList: [
        {
          value: 'female2',
          label: '日本語 | 女性 | 大人 | 02',
        },
      ],
      currentUseIVR: '1',
      currentResponseFlowList: [],
      currentResponseMode: 'user',
      currentVoice: null,
      currentContent: null,
      currentPhoneNumber: null,
      currentResponseUserGroupType: 'current', // 'current' or 'new'
      currentUserGroup: null,
      currentGroupName: '',
      currentUserList: [],
      userGroupList: [],
      userList: [],
      flowList: [],
      phoneNumber: '',
      voiceDXPhoneNumberList: [],
      currentAbsenceMail: '',
      currentEmailNotification: false,
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      settingDialogVisible: true,
      formData: {
        index: -1,
        name: '',
        response_mode: 'user',
        group_name: null,
        phone_number: '',
        notification: false,
        overflow_response_mode: '',
        condition: '',
        guidance: '',
        guidance_url: '',
        transfer_number: '',
        overflow_group_name: '',
        email_notification: false,
        absence_mail: '',
      },
      //音声
      audio: null,
      isVoicePlaying: false,

      isNormalModal: false,

      phone_number: this.$store.state.user.phoneNumber ? this.$store.state.user.phoneNumber : '',
      // For Trial
      savaButtonDisable: false,
      titleText: '',
      selectedCompanyID: '',
      // あふれ呼
      overflowResponseOptions: [
        {
          label: 'ガイダンスを流して留守電',
          value: 'answering',
        },
        {
          label: 'ガイダンスを流して切断',
          value: 'disconnect',
        },
        {
          label: '外線転送',
          value: 'transfer',
        },
        {
          label: '他の指定ユーザが着信',
          value: 'user',
        },
      ],
      overflowCall: {
        condition: '',
        guidance: '',
        guidance_url: '',
        transfer_number: '',
        group_name: '',
      },
      currentOverflowNotification: false,
      currentOverflowResponseMode: '',
      overflowCallCondition: '',
      overflowCallGuidance: '',
      overflowCallGuidanceURL: '',
      overflowTransferNumber: '',
      overflowGroupName: '',
      phoneNumberList: [], // 利用中の050番号一覧
      specificNumberSetting: {},
      specificNumberSettingOptions: [
        {
          label: '切断',
          value: 'disconnect',
        },
        {
          label: 'ガイダンスを流して留守電',
          value: 'voicemailGuidance',
        },
        {
          label: 'ガイダンスを流して切断',
          value: 'disconnectGuidance',
        },
        {
          label: '外線転送',
          value: 'transfer',
        },
        {
          label: 'COTOHA Voice DX Basic転送',
          value: 'voiceDXTransfer',
        },
        {
          label: '他の指定ユーザが着信',
          value: 'user',
        },
      ],
      companyName: '',
      flowListRaw: null,
      specificNumberSettingRaw: null,
      overseasNumberFlag: false,
      withheldNumberFlag: false,
      noIvrGuidanceSetting: {},
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-ivr-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
    userGroupOptions() {
      return this.userGroupList.map(group => {
        return {
          label: group.group_name,
          value: group.group_id,
        };
      });
    },
    settingModalTitle() {
      if (this.formData.index !== -1) {
        const index = this.formData.index || 0;
        return `プッシュ番号${index + 1}`;
      }
      return '';
    },
    isGeneralOperator() {
      return this.companyID !== POINT && this.authInfo === 'operator';
    },
    isCOMOperator() {
      return this.companyID === POINT && this.authInfo === 'operator';
    },
    viewOnly() {
      return this.isCOMOperator;
    },
  },
  watch: {
    isDataLoaded(val) {
      this.setLoading(!val);
    },
    $route(to, from) {
      if (this.audio && this.audio.state === 'running') this.audio.close();
    },
  },
  async created() {
    if (this.isGeneralOperator) this.$router.push({ name: 'PermissionDenied' });
    if (this.$route.query.companyID) {
      this.selectedCompanyID = this.$route.query.companyID;
    }
    await this.loadSetting();
  },
  mounted() {
    this.settingDialogVisible = false;
    if (utils.chkTrialCompanyID(this.companyID) || utils.chkTrialCompanyID(this.selectedCompanyID)) {
      this.savaButtonDisable = true;
      this.isNormalModal = false;
      this.showStartModal(messageContent.notifyTrialUserCanNotSave());
    }
  },
  methods: {
    getPayloadData() {
      const payload = {
        use_ivr: this.currentUseIVR === '1',
        overseasNumberFlag: this.overseasNumberFlag,
        withheldNumberFlag: this.withheldNumberFlag,
      };
      if (payload.use_ivr) {
        // IVRあり
        payload.ivr = {
          flows: cloneDeep(this.currentResponseFlowList),
          voice: this.currentVoice,
          content: this.currentContent,
          absenceMail: this.currentAbsenceMail,
          mailFlag: this.currentEmailNotification,
        };
      } else {
        // IVRなし
        // AGENT
        payload.agent = {
          response_mode: this.currentResponseMode,
        };
        if (this.currentResponseMode === 'user') {
          // USER GROUP
          payload.agent.user_group = {
            mode: this.currentResponseUserGroupType,
          };
          if (this.currentResponseUserGroupType === 'current') {
            payload.agent.user_group.group_id = this.currentUserGroup;
          } else {
            payload.agent.user_group.group_name = this.currentGroupName;
            const user_list = cloneDeep(this.currentUserList);
            for (const id in user_list) {
              user_list[id] = this.userList[user_list[id]].clientName;
            }

            payload.agent.user_group.user_list = user_list;
          }
        } else {
          // TRANSFER
          if (!this.phoneNumberList.includes(this.currentPhoneNumber)) {
            payload.agent.transfer = {
              phone_number: this.currentPhoneNumber,
            };
          } else {
            this.showErrorModal(messageContent.notSetTransferNumber);
            this.setLoading(false);
            return null;
          }
        }
        let tmpGroupName = '';
        if (payload.agent.response_mode === 'user') {
          tmpGroupName =
            this.currentResponseUserGroupType === 'new'
              ? payload.agent.user_group.group_name
              : payload.agent.user_group.group_id;
          // あふれ呼
          payload.agent.overflow_flag = this.currentOverflowNotification;
          if (payload.agent.overflow_flag) {
            // ON時
            payload.agent.overflow_response_mode = this.currentOverflowResponseMode;
            if (payload.agent.overflow_response_mode === 'answering') {
              // 「ガイダンスを流して留守電」
              this.overflowCallCondition = 'voiceMessage';

              // メール通知データセット
              payload.agent.overflow_email_notification = this.overflowEmailNotification;
              payload.agent.overflow_absence_mail = this.overflowAbsenceMail;
            }
            if (payload.agent.overflow_response_mode === 'disconnect') {
              // 「ガイダンスを流して切断」
              this.overflowCallCondition = 'onlyGuidance';

              // メール通知データセット
              payload.agent.overflow_email_notification = this.overflowEmailNotification;
              payload.agent.overflow_absence_mail = this.overflowAbsenceMail;
            }
            if (
              payload.agent.overflow_response_mode === 'transfer' ||
              payload.agent.overflow_response_mode === 'voiceDX'
            ) {
              // 「外線転送」or 「COTOHA Voice DX Basic転送」
              this.overflowCallCondition = 'transferCall';
            }
            if (payload.agent.overflow_response_mode === 'user') {
              // 「他の指定ユーザが着信」
              this.overflowCallCondition = 'incomingCall';
            }
            payload.agent.overflow_call_condition = this.overflowCallCondition;
            payload.agent.overflow_call_guidance = this.overflowCallGuidance;
            payload.agent.overflow_transfer_number = this.overflowTransferNumber;
            if (
              this.overflowCallCondition === 'transferCall' &&
              this.phoneNumberList.includes(this.overflowTransferNumber)
            ) {
              this.showErrorModal(messageContent.notSetTransferNumber);
              this.setLoading(false);
              return null;
            }
            payload.agent.overflow_group_name = this.overflowGroupName;
            if (this.overflowCallCondition === 'incomingCall' && payload.agent.overflow_group_name === tmpGroupName) {
              // #4152対応：あふれ呼で「他の着信グループに転送」のときに元のグループと転送先のグループが同一のときはエラーとする
              this.showErrorModal(messageContent.notSameGroupName);
              this.setLoading(false);
              return null;
            }
          } else {
            // あふれ呼設定をOFF
            payload.agent.overflow_flag = false;
            payload.agent.overflow_response_mode = '';
            payload.agent.overflow_call_condition = '';
            payload.agent.overflow_call_guidance = '';
            payload.agent.overflow_transfer_number = '';
          }
        } else {
          // あふれ呼設定をOFF
          payload.agent.overflow_flag = false;
          payload.agent.overflow_response_mode = '';
          payload.agent.overflow_call_condition = '';
          payload.agent.overflow_call_guidance = '';
          payload.agent.overflow_transfer_number = '';
        }
        // 特定番号対応の設定
        payload.agent.specificNumberSetting = this.specificNumberSettingStandardization(this.specificNumberSetting);
        // 自動音声ガイダンスを設定
        payload.agent.noIvrGuidanceSetting = this.noIvrGuidanceSetting;
      }
      return payload;
    },
    async getGuidanceURL(filename, content) {
      const res = await this.postRequest('/callflow/cotohattsupload', {
        data: { [filename]: content },
        companyID: this.selectedCompanyID,
        selectedPhoneNumber: this.phoneNumber,
      });
      if (res.status !== 'success') {
        this.showErrorModal(messageContent.requireTry('音声作成'));
        throw new Error(messageContent.requireTry('音声作成'));
      }
      return res.data.guidanceURL ? res.data.guidanceURL[`${filename}URL`] : '';
    },
    async handleFormSubmit(e) {
      try {
        this.setLoading(true);
        e.preventDefault();
        // payloadデータを準備する
        const payload = this.getPayloadData();
        if (!payload) {
          this.setLoading(false);
          return;
        }
        // payloadデータをvalidate
        if (!this.validateForm(payload)) {
          this.setLoading(false);
          return;
        }
        // IVRありの場合、各種ガイダンスURLを作成する
        if (payload.use_ivr && payload.ivr && payload.ivr.content && payload.ivr.content.trim()) {
          // IVRのガイダンスURL作成
          payload.ivr.pbGuidanceURL = await this.getGuidanceURL('pbGuidance', payload.ivr.content);
          payload.ivr.content = payload.ivr.content.replace(/\n/g, '%%n%%'); // #2138
          // あふれ呼と特定番号のガイダンスURL作成
          for (const i in payload.ivr.flows) {
            const flow = payload.ivr.flows[i];
            // あふれ呼ガイダンスURL作成
            if (
              flow.overflowCallFlag &&
              (flow.overflowCallCondition === 'voiceMessage' || flow.overflowCallCondition === 'onlyGuidance') &&
              flow.overflowCallGuidance &&
              flow.overflowCallGuidance.trim()
            ) {
              flow.overflowCallGuidanceURL = await this.getGuidanceURL(
                `overflowCallGuidance${i}`,
                flow.overflowCallGuidance
              );
              flow.overflowCallGuidance = flow.overflowCallGuidance.replace(/\n/g, '%%n%%');
            }
            // 特定番号ガイダンスURL作成
            if (
              flow.specificNumberSetting &&
              flow.specificNumberSetting.specificNumberFlag &&
              flow.specificNumberSetting.specificNumberCondition === 'voicemailGuidance'
            ) {
              // 留守電ガイダンス
              flow.specificNumberSetting.specificNumberVoicemailGuidanceURL = await this.getGuidanceURL(
                `specificNumberVoicemailGuidance${i}`,
                flow.specificNumberSetting.specificNumberVoicemailGuidance
              );
              flow.specificNumberSetting.specificNumberVoicemailGuidance =
                flow.specificNumberSetting.specificNumberVoicemailGuidance.replace(/\n/g, '%%n%%');
            }
            if (
              flow.specificNumberSetting &&
              flow.specificNumberSetting.specificNumberFlag &&
              flow.specificNumberSetting.specificNumberCondition === 'disconnectGuidance'
            ) {
              // 切断ガイダンス
              flow.specificNumberSetting.specificNumberDisconnectGuidanceURL = await this.getGuidanceURL(
                `specificNumberDisconnectGuidance${i}`,
                flow.specificNumberSetting.specificNumberDisconnectGuidance
              );
              flow.specificNumberSetting.specificNumberDisconnectGuidance =
                flow.specificNumberSetting.specificNumberDisconnectGuidance.replace(/\n/g, '%%n%%');
            }
          }
        }
        // IVRなし場合、あふれ呼のガイダンスURLを作成する
        if (!payload.use_ivr && this.currentResponseMode === 'voiceDX') {
          payload.agent.response_mode = 'transfer';
        }
        if (
          !payload.use_ivr &&
          payload.agent.overflow_flag &&
          (payload.agent.overflow_call_condition === 'voiceMessage' ||
            payload.agent.overflow_call_condition === 'onlyGuidance')
        ) {
          // あふれ呼 音声合成
          if (payload.agent.overflow_call_guidance && payload.agent.overflow_call_guidance.trim()) {
            payload.agent.overflow_call_guidanceurl = await this.getGuidanceURL(
              'overflowCallGuidance',
              payload.agent.overflow_call_guidance
            );
            payload.agent.overflow_call_guidance = payload.agent.overflow_call_guidance.replace(/\n/g, '%%n%%');
          }
        }
        // IVRなし場合、特定番号のガイダンスURLを作成する
        if (
          !payload.use_ivr &&
          payload.agent.specificNumberSetting &&
          payload.agent.specificNumberSetting.specificNumberFlag &&
          payload.agent.specificNumberSetting.specificNumberCondition === 'voicemailGuidance'
        ) {
          payload.agent.specificNumberSetting.specificNumberVoicemailGuidanceURL = await this.getGuidanceURL(
            'specificNumberVoicemailGuidance',
            payload.agent.specificNumberSetting.specificNumberVoicemailGuidance
          );
          payload.agent.specificNumberSetting.specificNumberVoicemailGuidance =
            payload.agent.specificNumberSetting.specificNumberVoicemailGuidance.replace(/\n/g, '%%n%%');
        }
        if (
          !payload.use_ivr &&
          payload.agent.specificNumberSetting &&
          payload.agent.specificNumberSetting.specificNumberFlag &&
          payload.agent.specificNumberSetting.specificNumberCondition === 'disconnectGuidance'
        ) {
          payload.agent.specificNumberSetting.specificNumberDisconnectGuidanceURL = await this.getGuidanceURL(
            'specificNumberDisconnectGuidance',
            payload.agent.specificNumberSetting.specificNumberDisconnectGuidance
          );
          payload.agent.specificNumberSetting.specificNumberDisconnectGuidance =
            payload.agent.specificNumberSetting.specificNumberDisconnectGuidance.replace(/\n/g, '%%n%%');
        }
        // IVRなし場合の自動音声ガイダンスを作成する
        if (
          !payload.use_ivr &&
          payload.agent.noIvrGuidanceSetting &&
          payload.agent.noIvrGuidanceSetting.noIVRGuidanceFlag
        ) {
          payload.agent.noIvrGuidanceSetting.noIVRGuidanceURL = await this.getGuidanceURL(
            'noIVRGuidance',
            payload.agent.noIvrGuidanceSetting.noIVRGuidance
          );
        }
        // 設定をDBに保存する
        await this.handleSaveClick(payload);
        this.setLoading(false);
      } catch (error) {
        console.log('着信フロー保存エラー', error);
        this.setLoading(false);
      }
    },
    specificNumberSettingStandardization(setting) {
      const specificNumberSetting = {
        specificNumberFlag: setting ? setting.specificNumberFlag : false,
        specificNumberList: [],
        specificNumberCondition: '',
        specificNumberVoicemailGuidance: '',
        specificNumberVoicemailGuidanceURL: '',
        specificNumberDisconnectGuidance: '',
        specificNumberDisconnectGuidanceURL: '',
        specificNumberNotificationFlag: false,
        specificNumberNotificationEmail: '',
        specificNumberTransferNumber: '',
        specificNumberVoiceDXTransferNumber: '',
        specificNumberGroupName: '',
      };
      if (specificNumberSetting.specificNumberFlag) {
        specificNumberSetting.specificNumberCondition = setting.specificNumberCondition;
        specificNumberSetting.specificNumberList = setting.specificNumberList;
        if (setting.specificNumberCondition === 'voicemailGuidance') {
          specificNumberSetting.specificNumberVoicemailGuidance = setting.specificNumberVoicemailGuidance;
        }
        if (setting.specificNumberCondition === 'disconnectGuidance') {
          specificNumberSetting.specificNumberDisconnectGuidance = setting.specificNumberDisconnectGuidance;
          specificNumberSetting.specificNumberNotificationFlag = setting.specificNumberNotificationFlag;
          if (specificNumberSetting.specificNumberNotificationFlag) {
            specificNumberSetting.specificNumberNotificationEmail = setting.specificNumberNotificationEmail;
          }
        }
        if (setting.specificNumberCondition === 'transfer') {
          specificNumberSetting.specificNumberTransferNumber = setting.specificNumberTransferNumber;
        }
        if (setting.specificNumberCondition === 'voiceDXTransfer') {
          specificNumberSetting.specificNumberVoiceDXTransferNumber = setting.specificNumberVoiceDXTransferNumber;
        }
        if (setting.specificNumberCondition === 'user') {
          specificNumberSetting.specificNumberGroupName = setting.specificNumberGroupName;
        }
      }
      return specificNumberSetting;
    },
    validateFlow(flow) {
      if (flow.active && flow.settingName && flow.responseMode && flow.value) {
        return 'complete';
      }
      if (flow.active && (!flow.settingName || !flow.responseMode || flow.value)) {
        return 'incomplete';
      }
      return 'unset';
    },
    validateForm(payload) {
      // Validate flows
      if (payload.use_ivr) {
        let count = 0;
        for (const i in payload.ivr.flows) {
          const flow = payload.ivr.flows[i];
          const result = this.validateFlow(flow);
          if (result === 'complete') {
            count++;
          } else if (result === 'incomplete') {
            const n = parseInt(i) + 1;
            this.showErrorModal(messageContent.requirePushNumberX(String(n)));
            return false;
          }
          // あふれ呼
          if (flow.overflowCallFlag) {
            const overflowForm = {
              response_mode: flow.overflowResponseMode,
              condition: flow.overflowCallCondition,
              guidance: flow.overflowCallGuidance,
              transfer_number: flow.overflowTransferNumber,
              group_name: flow.overflowGroupName,
              email_notification: flow.overflowEmailNotification,
              absence_mail: flow.overflowAbsenceMail,
            };
            const overflowFlag = this.validateOverflow(overflowForm);
            if (!overflowFlag) {
              return false;
            }
          }
        }
        if (count === 0) {
          this.showErrorModal(messageContent.requirePushNumber);
          return false;
        }
      }
      // Validate guidance content
      if (payload.use_ivr) {
        const lengthCheck = this.guidanceLengthCheck(payload.ivr.content);
        if (!lengthCheck.status) {
          this.showErrorModal(lengthCheck.message);
          return false;
        }
      }
      if (payload.use_ivr && !payload.ivr.content) {
        this.showErrorModal(messageContent.emptyGuidanceError);
        return false;
      }
      // Only space check for guidance
      if (payload.use_ivr) {
        const onlySpaceChk = this.onlySpaceCheck(payload.ivr.content, 'ガイダンス内容');
        if (!onlySpaceChk.status) {
          this.showErrorModal(onlySpaceChk.message);
          return false;
        }
      }
      if (payload.use_ivr && payload.ivr.content && this.hasSpecialCharacterInObject(payload.ivr.content)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return false;
      }
      if (payload.use_ivr) {
        const charCheck = this.guidanceCharCheck(payload.ivr.content);
        if (!charCheck.status) {
          this.showErrorModal(charCheck.message);
          return false;
        }
      }
      // Validate email
      if (payload.use_ivr && payload.ivr.mailFlag) {
        const lengthCheck = this.emailLengthCheck(payload.ivr.absenceMail);
        if (!lengthCheck.status) {
          this.showErrorModal(lengthCheck.message);
          return false;
        }
        if (typeof payload.ivr.absenceMail !== 'undefined' && !this.addressCheck(payload.ivr.absenceMail)) {
          this.showErrorModal(messageContent.incorrectEmailFormat);
          return false;
        }
      }
      // Validate new group name
      if (!payload.use_ivr && payload.agent.response_mode === 'user' && payload.agent.user_group.mode === 'new') {
        if (!payload.agent.user_group.group_name) {
          this.showErrorModal(messageContent.requireIncomingGroupName);
          return false;
        }
        if (
          payload.agent.user_group.group_name &&
          this.hasSpecialCharacterInObject(payload.agent.user_group.group_name)
        ) {
          this.showErrorModal(messageContent.hasSpecialCharacter);
          return false;
        }
        if (payload.agent.user_group.user_list.length === 0) {
          this.showErrorModal(messageContent.requireUser);
          return false;
        }
        if (payload.agent.user_group.user_list.length > 10) {
          this.showErrorModal(messageContent.exceedMaxUserPerGroup);
          return false;
        }
      }
      // Validate current group name
      if (!payload.use_ivr && payload.agent.response_mode === 'user' && payload.agent.user_group.mode === 'current') {
        if (!payload.agent.user_group.group_id) {
          this.showErrorModal(messageContent.requireIncomingGroup);
          return false;
        }
      }
      // Validate transfer number
      if (!payload.use_ivr && payload.agent.response_mode === 'transfer') {
        if (!payload.agent.transfer.phone_number) {
          this.showErrorModal(messageContent.requirePhonenumber);
          return false;
        }
        if (!this.numberOnly(payload.agent.transfer.phone_number)) {
          this.showErrorModal(messageContent.phonenumberIsNotHalfWidth);
          return false;
        }
        if (payload.agent.transfer.phone_number.length !== 11 && payload.agent.transfer.phone_number.length !== 10) {
          this.showErrorModal(messageContent.invalidDigitsNumberOfPhoneNumber);
          return false;
        }
      }
      if (!payload.use_ivr && payload.agent.response_mode === 'voiceDX') {
        if (!this.voiceDXPhoneNumberList.some(v => v.value === payload.agent.transfer.phone_number)) {
          this.showErrorModal(messageContent.requirePhonenumberOfVDXB);
          return false;
        }
      }
      // あふれ呼
      if (!payload.use_ivr && payload.agent.overflow_flag) {
        const overflowForm = {
          response_mode: payload.agent.overflow_response_mode,
          condition: payload.agent.overflow_call_condition,
          guidance: payload.agent.overflow_call_guidance,
          transfer_number: payload.agent.overflow_transfer_number,
          group_name: payload.agent.overflow_group_name,
          email_notification: payload.agent.overflow_email_notification,
          absence_mail: payload.agent.overflow_absence_mail,
        };
        const overflowFlag = this.validateOverflow(overflowForm);
        if (!overflowFlag) {
          return false;
        }
      }
      // 特定番号対応の設定
      if (!payload.use_ivr) {
        const specificNumberSetting = payload.agent.specificNumberSetting;
        if (
          payload.agent.response_mode === 'user' &&
          specificNumberSetting.specificNumberCondition === 'user' &&
          payload.agent.user_group.group_id === specificNumberSetting.specificNumberGroupName
        ) {
          this.showErrorModal(messageContent.specificNumberGroupCanNotSameAsOverflowGroup);
          return false;
        }
        if (!this.validateSpecificNumberSetting(specificNumberSetting)) return false;
      }
      // 自動音声ガイダンスを設定
      if (!payload.use_ivr) {
        if (this.noIvrGuidanceSetting.noIVRGuidanceFlag) {
          const guidance = this.noIvrGuidanceSetting.noIVRGuidance;
          // Validate guidance content
          const lengthCheck = this.guidanceLengthCheck(guidance);
          if (!lengthCheck.status) {
            this.showErrorModal(lengthCheck.message);
            return false;
          }
          // check empty
          if (!guidance) {
            this.showErrorModal(messageContent.emptyGuidanceError);
            return false;
          }
          // Only space check for guidance
          const onlySpaceChk = this.onlySpaceCheck(guidance, 'ガイダンス内容');
          if (!onlySpaceChk.status) {
            this.showErrorModal(onlySpaceChk.message);
            return false;
          }
          if (this.hasSpecialCharacterInObject(guidance)) {
            this.showErrorModal(messageContent.hasSpecialCharacter);
            return false;
          }
          const charCheck = this.guidanceCharCheck(guidance);
          if (!charCheck.status) {
            this.showErrorModal(charCheck.message);
            return false;
          }
        }
      }
      return true;
    },
    validateSpecificNumberSetting(setting) {
      if (setting.specificNumberFlag) {
        // 特定番号を指定したかチェック
        if (!setting.specificNumberList.length) {
          this.showErrorModal(messageContent.specificNumberRequired);
          return false;
        }
        const guidance =
          setting.specificNumberCondition === 'disconnectGuidance'
            ? setting.specificNumberDisconnectGuidance
            : setting.specificNumberCondition === 'voicemailGuidance'
            ? setting.specificNumberVoicemailGuidance
            : '';
        // 特定番号の対応方法は「ガイダンスを流して切断」又は「ガイダンスを流して留守電」となる
        if (
          setting.specificNumberCondition === 'voicemailGuidance' ||
          setting.specificNumberCondition === 'disconnectGuidance'
        ) {
          // Validate guidance content
          const lengthCheck = this.guidanceLengthCheck(guidance);
          if (!lengthCheck.status) {
            this.showErrorModal(lengthCheck.message);
            return false;
          }
          // check empty
          if (!guidance) {
            this.showErrorModal(messageContent.emptyGuidanceError);
            return false;
          }
          // Only space check for guidance
          const onlySpaceChk = this.onlySpaceCheck(guidance, 'ガイダンス内容');
          if (!onlySpaceChk.status) {
            this.showErrorModal(onlySpaceChk.message);
            return false;
          }
          if (this.hasSpecialCharacterInObject(guidance)) {
            this.showErrorModal(messageContent.hasSpecialCharacter);
            return false;
          }
          const charCheck = this.guidanceCharCheck(guidance);
          if (!charCheck.status) {
            this.showErrorModal(charCheck.message);
            return false;
          }
        }
        // メール通知チェック
        if (setting.specificNumberCondition === 'disconnectGuidance' && setting.specificNumberNotificationFlag) {
          if (!setting.specificNumberNotificationEmail) {
            this.showErrorModal(messageContent.specificNumberNotificationEmailRequired);
            return false;
          }
          const lengthCheck = this.emailLengthCheck(setting.specificNumberNotificationEmail);
          if (!lengthCheck.status) {
            this.showErrorModal(lengthCheck.message);
            return false;
          }
          if (!this.addressCheck(setting.specificNumberNotificationEmail)) {
            this.showErrorModal(messageContent.incorrectEmailFormat);
            return false;
          }
        }
        // 外線転送番号チェック
        if (setting.specificNumberCondition === 'transfer') {
          if (!setting.specificNumberTransferNumber) {
            this.showErrorModal(messageContent.requirePhonenumber);
            return false;
          }
          if (!this.numberOnly(setting.specificNumberTransferNumber)) {
            this.showErrorModal(messageContent.phonenumberIsNotHalfWidth);
            return false;
          }
          if (
            setting.specificNumberTransferNumber.length !== 11 &&
            setting.specificNumberTransferNumber.length !== 10
          ) {
            this.showErrorModal(messageContent.invalidDigitsNumberOfPhoneNumber);
            return false;
          }
        }
        if (setting.specificNumberCondition === 'voiceDXTransfer') {
          if (!this.voiceDXPhoneNumberList.some(v => v.value === setting.specificNumberVoiceDXTransferNumber)) {
            this.showErrorModal(messageContent.requirePhonenumberOfVDXB);
            return false;
          }
        }
        if (setting.specificNumberCondition === 'user') {
          if (!setting.specificNumberGroupName) {
            this.showErrorModal(messageContent.requireIncomingGroup);
            return false;
          }
        }
      }
      return true;
    },
    validateOverflow(form) {
      if (form.condition === 'voiceMessage' || form.condition === 'onlyGuidance') {
        // 「ガイダンスを流して留守電」or「ガイダンスを流して切断」
        if (!form.guidance) {
          this.showErrorModal('あふれ呼 ' + messageContent.emptyGuidanceError);
          return false;
        }
        const lengthCheck = this.guidanceLengthCheck(form.guidance);
        if (!lengthCheck.status) {
          this.showErrorModal(lengthCheck.message);
          return false;
        }
        const onlySpaceChk = this.onlySpaceCheck(form.guidance, 'あふれ呼 ガイダンス内容');
        if (!onlySpaceChk.status) {
          this.showErrorModal(onlySpaceChk.message);
          return false;
        }
        if (form.guidance && this.hasSpecialCharacterInObject(form.guidance)) {
          this.showErrorModal(messageContent.hasSpecialCharacter);
          return false;
        }
        const charCheck = this.guidanceCharCheck(form.guidance);
        if (!charCheck.status) {
          this.showErrorModal(charCheck.message);
          return false;
        }
      }
      if (form.response_mode === 'transfer' && form.condition === 'transferCall') {
        // 「外線転送」
        if (!form.transfer_number) {
          this.showErrorModal('外線転送 電話番号を入力してください。');
          return false;
        }
        if (!this.numberOnly(form.transfer_number)) {
          this.showErrorModal('外線転送 電話番号は半角数字で入力してください。');
          return false;
        }
        if (form.transfer_number.length !== 11 && form.transfer_number.length !== 10) {
          this.showErrorModal('外線転送 電話番号は10桁または11桁を入力してください。');
          return false;
        }
      }
      if (form.response_mode === 'voiceDX' && form.condition === 'transferCall') {
        if (!this.voiceDXPhoneNumberList.some(v => v.value === form.transfer_number)) {
          // COTOHA Voice DX Basic転送
          this.showErrorModal('COTOHA Voice DX Basicでご契約の電話番号を選択してください。');
          return false;
        }
      }
      if (form.condition === 'incomingCall') {
        if (!form.group_name) {
          this.showErrorModal('あふれ呼 着信グループを選択してください。');
          return false;
        }
      } else if (form.condition === 'voiceMessage' || form.condition === 'onlyGuidance') {
        // メール通知アドレスフォーマットチェック
        if (this.overflowEmailNotification && !this.addressCheck(form.absence_mail)) {
          this.showErrorModal(messageContent.incorrectEmailFormat);
          return false;
        }
      }
      return true;
    },
    async handleSaveClick(formData) {
      await this.postRequest('/callflow/save', {
        companyID: this.companyID === POINT ? this.selectedCompanyID : this.companyID,
        callFlowNameID: this.$route.params.callFlowName,
        setting: formData,
      })
        .then(res => {
          if (res.status === 'success') {
            if (this.companyID === POINT) {
              this.showModal(this.storeItem('着信フロー'));
            } else {
              this.showModal(this.storeItem('着信フロー'));
            }
          } else if (res.status === 'failed') {
            this.showErrorModal(res.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.settingSavingError);
        });
    },
    goCallFlow() {
      if (this.companyID === POINT) {
        this.$router.push({
          name: 'CallFlow',
          query: { companyID: this.$route.query.companyID },
          params: { callFlowName: this.$route.params.callFlowName },
        });
      } else {
        this.$router.push({ name: 'CallFlow', params: { callFlowName: this.$route.params.callFlowName } });
      }
      this.isNormalModal = false;
    },
    handleHelpClick() {
      this.helpDialogVisible = true;
    },
    handleCloseHelpDialog() {
      this.helpDialogVisible = false;
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({
          name: 'CallFlow',
          query: { companyID: this.$route.query.companyID },
          params: { callFlowName: this.$route.params.callFlowName },
        });
      } else {
        this.$router.push({ name: 'CallFlow', params: { callFlowName: this.$route.params.callFlowName } });
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.isNormalModal = false;
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showModal(message) {
      this.isNormalModal = true;
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    // For Trial
    showStartModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    loadSetting: async function () {
      this.isDataLoaded = false;
      await this.postRequest('/callflow/edit', {
        companyID: this.companyID === POINT ? this.selectedCompanyID : this.companyID,
        callFlowNameID: this.$route.params.callFlowName,
      })
        .then(res => {
          const setting = res.data;
          this.companyName = res.companyName;
          this.phoneNumber = setting.phoneNumber;
          this.currentUseIVR = setting.currentUseIVR;
          this.voiceDXPhoneNumberList = setting.voiceDXData;
          const tmpcompanyID = this.companyID === POINT ? this.selectedCompanyID : this.companyID;
          if (utils.chkTrialCompanyID(tmpcompanyID)) {
            this.titleText = messageContent.titleTextTrial();
          } else {
            this.titleText = `${setting.numberName}（${this.phoneNumber}）の着信フロー`;
          }
          // 非通知番号設定
          this.withheldNumberFlag = setting.withheldNumberFlag;
          // 海外番号設定
          this.overseasNumberFlag = setting.overseasNumberFlag;
          // IVR場合
          if (setting.currentUseIVR === '1') {
            this.currentVoice = setting.currentVoice;
            this.currentContent = setting.currentContent;
            this.currentAbsenceMail = setting.absenceMail;
            this.currentEmailNotification = setting.mailFlag;
            // 表示の際は変換していた改行を元に戻す
            for (const i in setting.flows) {
              const flow = setting.flows[i];
              if (flow.overflowCallGuidance) {
                flow.overflowCallGuidance = flow.overflowCallGuidance.replace(/%%n%%/g, '\n');
              }
            }
            this.flowList = setting.flows;
            this.currentResponseFlowList = setting.flows;
            this.flowListRaw = cloneDeep(setting.flows);
          } else {
            // あふれ呼
            this.currentOverflowResponseMode = setting.overflowResponseMode;
            this.currentOverflowNotification = setting.overflowCallFlag;
            // 表示の際は改行を元に戻す
            if (setting.overflowCallGuidance) {
              setting.overflowCallGuidance = setting.overflowCallGuidance.replace(/%%n%%/g, '\n');
            }
            this.overflowCallGuidance = setting.overflowCallGuidance;
            this.overflowCallGuidanceURL = setting.overflowCallGuidanceURL;
            this.overflowTransferNumber = setting.overflowTransferNumber;
            this.overflowGroupName = setting.overflowGroupName;
            this.overflowEmailNotification = setting.overflowEmailNotification;
            this.overflowAbsenceMail = setting.overflowAbsenceMail;
          }
          // IVRなし、着信場合
          if (setting.currentUseIVR === '0' && setting.currentResponseMode === 'user') {
            this.currentResponseMode = 'user';
            this.currentResponseUserGroupType = 'current';
            this.currentUserGroup = setting.currentUserGroup;
            this.currentGroupName = setting.currentGroupName;
          }
          // IVRなし、転送場合
          if (setting.currentUseIVR === '0' && setting.currentResponseMode === 'transfer') {
            this.currentResponseMode = 'transfer';
            this.currentPhoneNumber = setting.currentPhoneNumber;
          }
          if (setting.currentUseIVR === '0' && setting.currentResponseMode === 'voiceDX') {
            this.currentResponseMode = 'voiceDX';
            this.currentPhoneNumber = setting.currentPhoneNumber;
          }
          // 自動音声ガイダンスを設定
          this.noIvrGuidanceSetting = {
            noIVRGuidanceFlag: res.data.noIVRGuidanceFlag,
            noIVRGuidance: res.data.noIVRGuidance,
          };
          // 特定番号設定
          const settingRaw = cloneDeep(res.data);
          this.specificNumberSetting = this.specificNumberSettingStandardization(settingRaw.specificNumberSetting);
          this.specificNumberSettingRaw = cloneDeep(this.specificNumberSetting);
          // Set user list, group list, flow list
          this.userList = setting.userList;
          this.userGroupList = setting.groupNameList;
          if (this.voiceDXPhoneNumberList.length !== 0) {
            this.responseOptions = [
              {
                label: '指定ユーザーが着信',
                value: 'user',
              },
              {
                label: '外線転送',
                value: 'transfer',
              },
              {
                label: 'COTOHA Voice DX Basic',
                value: 'voiceDX',
              },
            ];
            this.overflowResponseOptions = [
              {
                label: 'ガイダンスを流して留守電',
                value: 'answering',
              },
              {
                label: 'ガイダンスを流して切断',
                value: 'disconnect',
              },
              {
                label: '外線転送',
                value: 'transfer',
              },
              {
                label: 'COTOHA Voice DX Basic',
                value: 'voiceDX',
              },
              {
                label: '他の指定ユーザが着信',
                value: 'user',
              },
            ];
          }
          this.phoneNumberList = res.phoneNumberList;
          // Mark data is loaded
          this.isDataLoaded = true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleResponseFlowConfig(index) {
      if (this.currentResponseFlowList[index]) {
        const flow = this.currentResponseFlowList[index];
        this.formData.index = index;
        this.formData.name = flow.settingName;
        this.formData.response_mode = flow.responseMode ? flow.responseMode : null;
        this.formData.group_name = flow.groupName ? flow.groupName : null;
        this.formData.phone_number = flow.transferNumber;
        this.settingDialogVisible = true;
        // あふれ呼
        this.formData.notification = flow.overflowCallFlag;
        this.formData.overflow_response_mode = flow.overflowResponseMode;
        this.formData.condition = flow.overflowCallCondition;
        this.formData.guidance = flow.overflowCallGuidance;
        this.formData.guidance_url = flow.overflowCallGuidanceURL;
        this.formData.transfer_number = flow.overflowTransferNumber;
        this.formData.overflow_group_name = flow.overflowGroupName;
        this.formData.overflow_absence_mail = flow.overflowAbsenceMail;
        this.formData.overflow_email_notification = flow.overflowEmailNotification;
        // 特定番号
        this.formData.specificNumberSetting = flow.specificNumberSetting;
        // 特定番号original data
        if (this.flowListRaw) this.formData.specificNumberSettingRaw = this.flowListRaw[index];
      }
    },
    clearFormData() {
      this.formData.index = -1;
      this.formData.name = '';
      this.formData.response_mode = null;
      this.formData.group_name = null;
      this.formData.phone_number = '';
      // あふれ呼
      this.formData.notification = false;
      this.formData.overflow_response_mode = '';
      this.formData.condition = '';
      this.formData.guidance = '';
      this.formData.guidance_url = '';
      this.formData.transfer_number = '';
      this.formData.overflow_group_name = '';
      this.formData.overflow_absence_mail = '';
      this.formData.overflow_email_notification = '';
      // 特定番号
      this.formData.specificNumberSetting = {};
    },
    handleCancelDialog() {
      this.settingDialogVisible = false;
      this.clearFormData();
    },
    handleSubmitDialog() {
      const formData = cloneDeep(this.formData);
      if (!this.validateFormData(formData)) {
        return;
      }
      if (formData.index !== -1) {
        if (this.currentResponseFlowList[formData.index]) {
          const flow = this.currentResponseFlowList[formData.index];
          flow.responseMode = formData.response_mode;
          flow.settingName = formData.name;
          if (formData.response_mode === 'user') {
            flow.value = formData.group_name ? formData.group_name : null;
            flow.groupName = flow.value;
          } else {
            flow.value = formData.phone_number;
            flow.transferNumber = flow.value;
          }
          // あふれ呼(「指定ユーザが着信」選択時のみ)
          flow.overflowCallFlag = formData.notification;
          if (formData.response_mode === 'user' && flow.overflowCallFlag) {
            flow.overflowResponseMode = formData.overflow_response_mode;
            flow.overflowCallCondition = '';
            if (formData.overflow_response_mode === 'answering') {
              // 「ガイダンスを流して留守電」
              flow.overflowCallCondition = 'voiceMessage';

              // メール通知
              flow.overflowEmailNotification = formData.overflow_email_notification;
              flow.overflowAbsenceMail = formData.overflow_absence_mail;
            }
            if (formData.overflow_response_mode === 'disconnect') {
              // 「ガイダンスを流して切断」
              flow.overflowCallCondition = 'onlyGuidance';

              // メール通知
              flow.overflowEmailNotification = formData.overflow_email_notification;
              flow.overflowAbsenceMail = formData.overflow_absence_mail;
            }
            if (formData.overflow_response_mode === 'transfer' || formData.overflow_response_mode === 'voiceDX') {
              // 「外線転送」or 「COTOHA Voice DX Basic転送」
              flow.overflowCallCondition = 'transferCall';
            }
            if (formData.overflow_response_mode === 'user') {
              // 「他の指定ユーザが着信」
              flow.overflowCallCondition = 'incomingCall';
            }
            flow.overflowCallGuidance = formData.guidance;
            flow.overflowTransferNumber = formData.transfer_number;
            if (
              flow.overflowCallCondition === 'transferCall' &&
              this.phoneNumberList.includes(formData.transfer_number)
            ) {
              this.showErrorModal(messageContent.notSetTransferNumber);
              return;
            }
            flow.overflowGroupName = formData.overflow_group_name;
            if (
              flow.responseMode === 'user' &&
              flow.overflowCallCondition === 'incomingCall' &&
              flow.overflowGroupName === flow.groupName
            ) {
              // #4152対応：あふれ呼で「他の着信グループに転送」のときに元のグループと転送先のグループが同一のときはエラーとする
              this.showErrorModal(messageContent.notSameGroupName);
              return;
            }
            // あふれ呼項目チェック
            const overflowForm = {
              response_mode: flow.overflowResponseMode,
              condition: flow.overflowCallCondition,
              guidance: flow.overflowCallGuidance,
              transfer_number: flow.overflowTransferNumber,
              group_name: flow.overflowGroupName,
              email_notification: flow.overflowEmailNotification,
              absence_mail: flow.overflowAbsenceMail,
            };
            const overflowFlag = this.validateOverflow(overflowForm);
            if (!overflowFlag) {
              return;
            }
          } else {
            flow.overflowCallFlag = false;
            flow.overflowResponseMode = '';
            flow.overflowCallCondition = '';
            flow.overflowCallGuidance = '';
            flow.overflowTransferNumber = '';
            flow.overflowGroupName = '';
            flow.overflowEmailNotification = '';
            flow.overflowAbsenceMail = '';
          }
          // 特定番号設定データ
          flow.specificNumberSetting = this.specificNumberSettingStandardization(this.formData.specificNumberSetting);
        }
      }
      this.settingDialogVisible = false;
      this.clearFormData();
    },
    validateFormData(formData) {
      // Validate setting name
      if (!formData.name) {
        this.showErrorModal(messageContent.requireSettingName);
        return false;
      }
      // Only space check
      const onlySpaceChk = this.onlySpaceCheck(formData.name, '設定名称');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return false;
      }
      const lengthCheck = this.settingNameLengthCheck(formData.name);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return false;
      }
      if (formData.name && this.hasSpecialCharacterInObject(formData.name)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return false;
      }
      // Validate response mode
      if (!formData.response_mode) {
        this.showErrorModal(messageContent.requireCorrespondingMethod);
        return false;
      }
      // Validate group name
      if (formData.response_mode === 'user' && !formData.group_name) {
        this.showErrorModal(messageContent.selectIncomingGroupName);
        return false;
      } else if (formData.response_mode === 'transfer') {
        if (!this.numberOnly(formData.phone_number)) {
          this.showErrorModal(messageContent.phonenumberIsNotHalfWidth);
          return false;
        } else if (formData.phone_number.length !== 11 && formData.phone_number.length !== 10) {
          this.showErrorModal(messageContent.invalidDigitsNumberOfPhoneNumber);
          return false;
        } else if (this.phoneNumberList.includes(formData.phone_number)) {
          this.showErrorModal(messageContent.notSetTransferNumber);
          return false;
        }
      } else if (formData.response_mode === 'voiceDX') {
        if (!this.voiceDXPhoneNumberList.some(v => v.value === formData.phone_number)) {
          this.showErrorModal(messageContent.requirePhonenumberOfVDXB);
          return false;
        }
      }
      if (formData.specificNumberSetting && formData.specificNumberSetting.specificNumberFlag) {
        if (
          formData.response_mode === 'user' &&
          formData.specificNumberSetting.specificNumberCondition === 'user' &&
          formData.group_name === formData.specificNumberSetting.specificNumberGroupName
        ) {
          this.showErrorModal(messageContent.specificNumberGroupCanNotSameAsOverflowGroup);
          return false;
        }
        return this.validateSpecificNumberSetting(formData.specificNumberSetting);
      }

      if (formData.overflow_email_notification && !this.addressCheck(formData.overflow_absence_mail)) {
        this.showErrorModal(messageContent.incorrectEmailFormat);
        return false;
      }

      return true;
    },
    async handlePlayVoice(data) {
      if (!data.content) {
        this.showErrorModal(messageContent.emptyGuidanceError);
        return;
      }
      if (data.content && this.hasSpecialCharacterInObject(data.content)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }
      const lengthCheck = this.guidanceLengthCheck(data.content);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return;
      }
      const charCheck = this.guidanceCharCheck(data.content);
      if (!charCheck.status) {
        this.showErrorModal(charCheck.message);
        return;
      }
      if (this.audio && this.audio.state === 'running') this.audio.close();
      this.isVoicePlaying = true;
      const self = this;
      await this.postRequest('/callflow/testvoice', {
        content: data.content,
        selectedCompanyID: this.selectedCompanyID,
        selectedPhoneNumber: this.phoneNumber,
      })
        //this.postRequest('/cotohattsupload/testvoice', { content: data.content, companyID: this.selectedCompanyID })
        .then(async data => {
          if (data.status === 'success' && data.data.voiceBufferData) {
            self.audio = null;
            self.audio = new AudioContext();
            const arr = Uint8Array.from(data.data.voiceBufferData.data);
            const audio = await self.audio.decodeAudioData(arr.buffer);
            const source = self.audio.createBufferSource();
            source.buffer = audio;
            source.connect(self.audio.destination);
            source.start(0);
            source.onended = function () {
              self.isVoicePlaying = false;
            };
          } else {
            this.isVoicePlaying = false;
            self.showErrorModal(messageContent.playbackError);
          }
        })
        .catch(error => {
          this.isVoicePlaying = false;
          self.showErrorModal(messageContent.playbackError);
        });
    },
    handleStopVoice() {
      if (this.audio && this.audio.state === 'running') {
        const self = this;
        this.audio.close().then(function () {
          self.isVoicePlaying = false;
        });
      }
    },
  },
};
</script>
